import useUiStore from '../../shared/store/ui.store.tsx'
import { SidebarTypes } from './Sidebar.tsx'
import type { FC } from 'react'

const AudioLibrary: FC = () => {
  const sidebarType = useUiStore((state) => state.sidebarType)

  const Library = sidebarType ? SidebarTypes[sidebarType] : undefined

  return Library && <Library />
}

export default AudioLibrary
